import React, { useEffect, useState } from "react";
import Button from '@mui/material/Button'
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ListItemIcon from '@mui/material/ListItemIcon';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorIcon from '@mui/icons-material/Error';



const InformationDialog = (props) =>{ 

    const { tsvReport, onClose } = props;

    const [openNonDefined, setOpenNonDefined] = useState(false);
    const [openErrors, setOpenErrors] = useState(false);

    const handleNonDefined = () => {
        setOpenNonDefined(!openNonDefined);
    };

    const handleErrors = () => {
        setOpenErrors(!openErrors);
    };

    const expandableOptionButton = (clickHandler, booleanController, arrayFields, error, titleText) => {
        return(
            <div>
                <ListItemButton onClick={clickHandler}>
                    <ListItemIcon>
                        {
                            (error)?
                                <ErrorIcon/>
                            :
                                <WarningAmberIcon/>
                        }
                    </ListItemIcon>
                    <ListItemText primary={arrayFields.length + " " + titleText} />
                        {booleanController ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                    <Collapse in={booleanController} timeout="auto" unmountOnExit>
                        <List component="div" disablePadding>
                            { arrayFields.map(item => {
                                return (
                                    <ListItemText primary={item} />  
                                )
                            })}
                        </List>  
                    </Collapse>
            </div>
        );
    }

    return(
        <Dialog onClose={onClose} open={tsvReport.openInformationDialog}>
            <DialogTitle id="alert-dialog-title">
                Your submitted TSV file have issues!
            </DialogTitle>

            <DialogContent>
                <List sx={{ width: '100%', maxWidth: 360, maxHeight:400, bgcolor: 'background.paper' }}
                      component="nav"
                      aria-labelledby="nested-list-subheader"
                      subheader={
                            <ListSubheader component="div" id="nested-list-subheader">
                                Issues detected
                            </ListSubheader>
                    }
                >
                    {/* Non defined files for preselected experiments*/}
                    {(props.tsvReport.nonDefinedLocalIds.length > 0) ?  
                        expandableOptionButton(handleNonDefined,openNonDefined,props.tsvReport.nonDefinedLocalIds,
                                               false,"Preselected experiments without files associated")
                        :
                        null
                    }  
                    {/* Errors on experiments*/}
                    {(props.tsvReport.localIdsErrors.length > 0) ?  
                        expandableOptionButton(handleErrors,openErrors,props.tsvReport.localIdsErrors,
                                               true,"Experiments with errors")
                        :
                        null
                    }                    
                </List>
            </DialogContent>

            <DialogActions>
                <Button onClick={onClose} autoFocus>
                    Accept
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default InformationDialog;